import React, { forwardRef } from "react";

import { useNavigate } from "react-router-dom";

import { Dialog, DialogContent, Slide, Typography } from "@mui/material";
import { TransitionProps } from "@mui/material/transitions";

import { Trans, useTranslation } from "react-i18next";

import { useOfflineContext } from "../../context/Offline";
import { useReceptionistPhone } from "../../lib/hooks/useQueryBoard";

const Transition = forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const OfflineModal = () => {
  const { t } = useTranslation(["offline"]);

  const navigate = useNavigate();
  const { online } = useOfflineContext();
  const receptionistPhone = useReceptionistPhone();

  if (online) {
    return null;
  }

  return (
    <Dialog
      fullScreen
      open={true}
      onClose={() => { navigate("/") }}
      TransitionComponent={Transition}
      sx={{ p: 3, "& .MuiPaper-root": { borderRadius: 2 } }}
    >
      <DialogContent sx={{
        display: "flex",
        flexDirection: "column",
        textAlign: "center",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100%",
      }}>
        <Typography variant="h1" sx={{ px: 4 }}>
          {t("offline:receptionMessage")}
        </Typography>
        {receptionistPhone && <Typography variant="h1" sx={{ px: 4 }}>
          {t("offline:check", { receptionistPhone })}
        </Typography>}
      </DialogContent>
    </Dialog>
  );
}

export default OfflineModal;